<template>
  <div class="content-8__controlbar">
    <div v-if="Object.keys(longHuMappingList).length > 0" class="content-8__controlbar__item">
      <div class="c8-itemtitle">
        <span class="c8-itemtitle__text">今日双面统计</span>
      </div>
      <div class="table-scroll" style="margin-bottom: 16px">
        <table class="even-color">
          <thead>
            <tr>
              <th>
                <span v-if="lotteryType === 'pk10'">名次</span>
                <span v-if="lotteryType === 'kl10'">球位</span>
              </th>
              <th v-for="hm in hmList" :key="hm.key" :colspan="hm.colSpan">
                <span>{{ hm.tableName }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in tableRows1" :key="`rule-jinRiShuangMian-table-${row.index}`">
              <td><span>{{ row.name }}</span></td>
              <td v-for="(item, index) in row.list" :key="index">
                <span v-if="row.index === 0">{{ item.label }}</span>
                <span v-if="row.index === 1">{{ gethmRowData(item) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <table class="even-color">
        <thead>
          <tr>
            <th>
              <span v-if="lotteryType === 'pk10'">冠亚龙虎</span>
              <span v-if="lotteryType === 'kl10'">总和/龙虎</span>
            </th>
            <th v-for="longHu in longHuSeriesList" :key="longHu.key" :colspan="longHu.colSpan">
              <span>{{ longHu.tableName }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in tableRows2" :key="`rule-jinRiShuangMian-table-${row.index}`">
            <td><span>{{ row.name }}</span></td>
            <td v-for="(item, index) in row.list" :key="index">
              <span v-if="row.index === 0">{{ item.label }}</span>
              <span v-if="row.index === 1">{{ getLongHuRowData(item) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { fieldList, getRulesList } from '@/utils/steven/shungmiantonji-1'
import { getCpStatisticsByStatsType_web } from '@/api/desktop/statistic'
import get from 'lodash.get'
export default {
  name: 'Pk10Kl10ShungMianTonJi',
  props: {
    lotteryCode: {
      type: String,
      required: true,
      default: () => {
        console.error('ShungMianTonJi required key "lotteryCode"')
        return ''
      }
    },
    lotteryType: {
      type: String,
      required: true,
      default: () => {
        console.error('ShungMianTonJi required key "lotteryType"')
        return ''
      }
    }
  },
  data() {
    return {
      tableRows1: [
        { index: 0, name: '单双大小', list: [] },
        { index: 1, name: '出现次数', list: [] }
      ],
      tableRows2: [
        { index: 0, name: '单双大小龙虎', list: [] },
        { index: 1, name: '出现次数', list: [] }
      ],
      hmMappingList: [],
      longHuMappingList: []
    }
  },
  computed: {
    ...fieldList
  },
  created() {
    this.init()
    this.getDXDSHistoryStatistics(this.lotteryCode)
  },
  methods: {
    init() {
      for (let i = 0; i < this.hmList.length; i++) {
        const numList = JSON.parse(JSON.stringify(this.numList['hasntLongHu']))
        numList.forEach(num => {
          num.hm = `hm${i + 1}`
        })
        this.tableRows1[0].list = this.tableRows1[0].list.concat(numList)
        this.tableRows1[1].list = this.tableRows1[1].list.concat(numList)
      }

      for (let i = 0; i < this.longHuSeriesList.length; i++) {
        let numList
        if (i === 0 && this.lotteryType === 'pk10') {
          numList = JSON.parse(JSON.stringify(this.numList['sumGuanYa']))
          numList.forEach(num => {
            num.longHu = `sumguanya`
          })
        } else if (i === 0 && this.lotteryType === 'kl10') {
          numList = JSON.parse(JSON.stringify(this.numList['zongHe']))
          numList.forEach(num => {
            num.longHu = `all`
          })
        } else {
          numList = JSON.parse(JSON.stringify(this.numList['hasLongHu']))
          numList.forEach(num => {
            if (this.lotteryType === 'pk10') num.longHu = `group${i}_${11 - i}`
            if (this.lotteryType === 'kl10') num.longHu = `group${i}_${9 - i}`
          })
        }
        this.tableRows2[0].list = this.tableRows2[0].list.concat(numList)
        this.tableRows2[1].list = this.tableRows2[1].list.concat(numList)
      }
    },
    async getDXDSHistoryStatistics(code) {
      const [data, error] = await getCpStatisticsByStatsType_web('todayDxdsStatistics', {
        code,
        days: 1,
        rules: getRulesList(this.lotteryType)
      })
      if (error) return
      this.hmMappingList = this.formatHmList(data)
      this.longHuMappingList = this.formatLongHuList(data)
    },
    formatHmList(data) {
      return this.hmList.reduce((acc, hm) => {
        acc[hm.key] = this.numList['hasntLongHu'].reduce((item, num) => {
          item[num.key] = get(data, `${hm.key}.${num.parentKey}.${num.key}`, 0)
          return item
        }, {})
        return acc
      }, {})
    },
    formatLongHuList(data) {
      return this.longHuSeriesList.reduce((acc, longHu) => {
        if (longHu.key === 'sumguanya') {
          acc[longHu.key] = this.numList['sumGuanYa'].reduce((item, num) => {
            item[num.key] = get(data, `${longHu.key}.${num.parentKey}.${num.key}`, 0)
            return item
          }, {})
        } else if (longHu.key === 'all') {
          acc[longHu.key] = this.numList['zongHe'].reduce((item, num) => {
            item[num.key] = get(data, `${longHu.key}.${num.parentKey}.${num.key}`, 0)
            return item
          }, {})
        } else {
          acc[longHu.key] = this.numList['hasLongHu'].reduce((item, num) => {
            item[num.key] = get(data, `${longHu.key}.${num.parentKey}.${num.key}`, 0)
            return item
          }, {})
        }
        return acc
      }, {})
    },
    gethmRowData(item) {
      const key = item.key
      const hm = item.hm
      return this.hmMappingList[hm][key]
    },
    getLongHuRowData(item) {
      const key = item.key
      const longHu = item.longHu
      return this.longHuMappingList[longHu][key]
    }
  }
}
</script>
